import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { style: {"color":"#a1a5b7"} }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body fs-5" }
const _hoisted_7 = { class: "table-tenant" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt4 Users"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt4 Current Open Orders"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt4 Close Orders for the day"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt5 Users"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt5 Current Open Positions"),
    /*#__PURE__*/_createElementVNode("th", null, "Mt5 Closed Orders for the day")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Real", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Traction", -1)

import { ref, onMounted } from "vue";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TractionCheck',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>(null);

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryTractionData();
    data.value = res;
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, [
          _createTextVNode(" AU Traction Data Check "),
          _createElementVNode("span", _hoisted_4, "UTC Time( " + _toDisplayString(data.value?.fromDate) + " - " + _toDisplayString(data.value?.toDate) + " )", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: fetchData,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(data.value?.mt4Users), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.mt4OpenOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.mt4ClosedOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.mt5Users), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.mt5OpenOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.mt5ClosedOrders), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt4Users), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt4OpenOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt4ClosedOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt5Users), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt5OpenOrders), 1),
            _createElementVNode("td", null, _toDisplayString(data.value?.tractionMt5ClosedOrders), 1)
          ])
        ])
      ])
    ])), [
      [_directive_loading, isLoading.value]
    ])
  ]))
}
}

})